module.exports = __webpack_public_path__ + "img/PG.31bec0d6.svg";